import { Field, Form, Formik, useFormikContext } from 'formik';
import React from 'react';
import Modal from 'react-modal';
import ActivityFrame from '../../../components/activity-frame/activity-frame';
import Label from '../../../components/label/label';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { validateIntegerWithinBounds } from '../../../utilities/Validation';
import Tooltip from '../../../components/Tooltip/Tooltip';

export const SiteCodeModal = ({ onClose, isOpen, onSave, busy, currentSiteCode }) => {
    const { resetForm } = useFormikContext<any>();
    const { translate } = useLocale();

    const closeWizard = () => {
        resetForm();
        onClose();
    };

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={closeWizard}
        overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        <Formik
            enableReinitialize={true}
            initialValues={currentSiteCode ? { siteCode: currentSiteCode } : { siteCode: 0 }}
            onSubmit={onSave}>

            {({ errors }) => (
                <Form>
                    <ActivityFrame busy={busy} className={`flex flex-col absolute flex-grow bg-white bg-opacity-50 -mt-3 -ml-3 ${busy ? 'z-50 w-full h-full' : ''}`}>
                    </ActivityFrame>
                    <div className="flex flex-col pt-3 px-3 space-y-3 relative">
                        <div className="flex flex-row ">
                            <div className="flex flex-col flex-1">
                                <div className="flex flex-row justify-between">
                                    <Label htmlFor="siteCode"
                                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.newSiteCode)}:</Label>
                                    {errors.siteCode ? <span className='text-red-600 text-xs overflow-hidden'>{errors.siteCode}</span> : null}
                                </div>
                                <Field
                                    id="siteCodeInputFieldId"
                                    type="number"
                                    name="siteCode"
                                    min={0}
                                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                                    validate={validateIntegerWithinBounds}>
                                </Field>
                            </div>
                        </div>
                        <div className="flex flex-row justify-end bottom-0 right-0 pb-3">
                            <div className="flex flex-row mt-4">
                                <Tooltip text={translate.byKey(TranslationKeys.cancel)} direction="top" contentPositionX="start" show>
                                    <button
                                        className="flex justify-center secondary secondary-inverse py-1 px-5"
                                        type="button"
                                        onClick={closeWizard}>
                                        <div className="inline-block truncate" style={{ textOverflow: 'ellipsis', maxWidth: '50px' }}>
                                            {translate.byKey(TranslationKeys.cancel)}
                                        </div>
                                    </button>
                                </Tooltip>
                            </div>
                            <div className="flex flex-row justify-end mt-4 pl-3">
                                <Tooltip text={translate.byKey(TranslationKeys.save)} direction="top" contentPositionX="start" show>
                                    <button
                                        id='saveSiteCodeBtnId'
                                        className={`flex justify-center py-1 px-5 secondary ${errors.siteCode ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'}`}
                                        type="submit">
                                        <div className="inline-block truncate" style={{ textOverflow: 'ellipsis', maxWidth: '37px' }}>
                                            {translate.byKey(TranslationKeys.save)}
                                        </div>
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    </Modal>
};
